import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Container, Typography, Button, Stack } from "@mui/material";
import { ErrorOutline } from "@mui/icons-material";
import { Helmet } from "react-helmet-async";

const NAVY = "#0A1628";
const BLUE = "#1565C0";
const MUTED = "#6B7280";

const SubscriptionFailure: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm" sx={{ pt: 12, pb: 6, textAlign: "center" }}>
      <Helmet>
        <title>Payment Failed — Dr.Paw</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <Box sx={{
        width: 88, height: 88, borderRadius: "50%",
        bgcolor: "#FEF2F2", mx: "auto", mb: 3,
        display: "flex", alignItems: "center", justifyContent: "center",
      }}>
        <ErrorOutline sx={{ fontSize: 52, color: "#EF4444" }} />
      </Box>
      <Typography variant="h5" fontWeight={800} sx={{ color: NAVY, mb: 1 }}>
        Payment Failed
      </Typography>
      <Typography sx={{ color: MUTED, mb: 4 }}>
        Your Whish payment didn't go through. No charge was made — you can try again
        or choose a different payment method.
      </Typography>
      <Stack direction="row" spacing={2} justifyContent="center">
        <Button variant="outlined" onClick={() => navigate("/")}
          sx={{ borderRadius: "50px", px: 3, fontWeight: 600, borderColor: BLUE, color: BLUE }}>
          Back to Home
        </Button>
        <Button variant="contained" onClick={() => navigate(-1)}
          sx={{ borderRadius: "50px", px: 3, fontWeight: 700, bgcolor: BLUE, "&:hover": { bgcolor: "#0D47A1" } }}>
          Try Again
        </Button>
      </Stack>
    </Container>
  );
};

export default SubscriptionFailure;
